import type { Item } from '@/api/@types'
import i18n from '@/lib/i18n'
import type { KeyLabel } from '@/types'

export const ITEM_TITLE = i18n.t('item.title')

export const ITEM_SEARCH_TITLE = i18n.t('item.search.title')

export const ITEM_FIELDS: KeyLabel<Item> & {
  brandStartDate: string
} = {
  brandName: i18n.t('item.detail.brandName'),
  retailPrice: i18n.t('item.detail.retailPrice'),
  salonPrice: i18n.t('item.detail.salonPrice'),
  volume: i18n.t('item.detail.volume'),
  janCode: i18n.t('item.detail.janCode'),
  itemCode: i18n.t('item.detail.itemCode'),
  itemName: i18n.t('item.detail.itemName'),
  // isNonReturnable: '返品可否',
  latestOrderDate: i18n.t('item.detail.lastOrderDate'),
  salesStartDate: i18n.t('item.detail.salesStartDate'),
  brandStartDate: i18n.t('item.detail.brandStartDate'),
} as const

export const ITEM_FIELDS_WITH_BREAK = {
  retailPrice: [i18n.t('item.detail.retailPrice')],
} as const

// export const NON_RETURNABLE_FLG_VALUE = {
//   true: '不可',
//   false: '可',
// }

export type ItemStatus =
  | 'available'
  | 'unavailable'
  | 'expired'
  | 'forbidden'
  | 'noItemCode'
  | 'outOfStock'
  | 'discontinued'

export const ITEM_CARD_STATUS_LABEL: Record<ItemStatus, string> = {
  available: '',
  unavailable: i18n.t('item.card.status.unavailable'),
  expired: i18n.t('item.card.status.expired'),
  forbidden: i18n.t('item.card.status.forbidden'),
  noItemCode: i18n.t('item.card.status.noItemCode'), // NOTE: このステータスのitemの事例は未確認
  outOfStock: i18n.t('item.card.status.outOfStock'),
  discontinued: i18n.t('item.card.status.discontinued'),
}

export const KEYWORD_SEARCH_PLACEHOLDER = i18n.t(
  'item.search.placeholder.common'
)
